import React from 'react'
import Selectin from '../../section/Selection/Selectin'
import Carousels from '../../section/Carousel/Carousel'
import Sectionchaise from '../../section/Sectionchaise/Sectionchaise'
import SectionArmoire from '../../section/SectionArmoire/SectionArmoire'
import SectionTable from '../../section/SectionTable/SectionTable'
import NosActualite from '../../section/NosActualité/Actualite'
import NosClient from '../../section/Nos client/NosClient'
import SectionComptoir from '../../section/SectionComptoir/SectionComptoir'

const Home = () => {
  return (
    <>
      <Carousels />
      <Selectin />
      <Sectionchaise />
      <SectionArmoire />
      <SectionTable />
      <SectionComptoir/>
      <NosActualite />
      <NosClient />
    </>
  )
}

export default Home